import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { CircularProgress, Box } from '@mui/material';
import { useState } from 'react';
import { useGetIconQuery, useGetTitleQuery } from '@/app/(control-panel)/admin/settings/SettingsApi';

const Root = styled('div')(({ theme }) => ({
  '& > .logo-icon': {
    transition: theme.transitions.create(['width', 'height'], {
      duration: theme.transitions.duration.shortest,
      easing: theme.transitions.easing.easeInOut
    })
  },
  '& > .badge': {
    transition: theme.transitions.create('opacity', {
      duration: theme.transitions.duration.shortest,
      easing: theme.transitions.easing.easeInOut
    })
  }
}));

/**
 * The logo component.
 */
function Logo() {
  const { data: iconUrl } = useGetIconQuery();
  const { data: title, isLoading } = useGetTitleQuery();
  const [iconFailed, setIconFailed] = useState(false);
  const showIcon = !!iconUrl && !iconFailed;

  const words = title?.split(' ') || ['Director', 'Cloud Services'];
  const [firstWord, ...restWords] = words;
  const secondWord = restWords.join(' '); // Preserve the rest of the words

  return (
    <Root className="flex flex-1 items-center space-x-12">
      <div className="flex flex-1 items-center space-x-8 px-10">
        <Box className="h-28 w-28 ml-2 flex items-center justify-center">
          {showIcon && (
            <img
              className="logo-icon h-28 w-28"
              src={iconUrl}
              alt="logo"
              decoding="async"
              onError={() => setIconFailed(true)}
            />
          )}
        </Box>
        <div className="logo-text flex flex-col flex-auto gap-2">
          <Typography className="text-2xl tracking-light font-semibold leading-none">
            {isLoading ? <CircularProgress size={16} /> : firstWord}
          </Typography>
          <Typography
            className="text-[13.6px] tracking-light font-semibold leading-none"
            color="primary"
            sx={{
              color: '#82d7f7'
            }}
          >
            {isLoading ? <CircularProgress size={16} /> : secondWord}
          </Typography>
        </div>
      </div>
    </Root>
  );
}

export default Logo;
